export const SUCCESS_COLOR = '#54ac68';
export const THEME_COLOR = '#1f6294';
export const REACT_APP_COMPANY_NAME = process.env.REACT_APP_COMPANY_NAME;
